import styled from 'styled-components'

import { Section as SectionGS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Section = styled(SectionGS)`
  overflow: hidden;
  position: relative;
  padding-bottom: ${space['spacing-xxxl']};

  & > div > div {
    min-height: 400px;
  }

  .polygon-pink {
    position: absolute;
    top: 400px;
    right: ${space['spacing-xl']};
    transform: translateY(-50%);
    z-index: 2;
  }

  h2 {
    margin-bottom: ${space['spacing-md']};
    position: relative;
    z-index: 2;
  }

  .ds-button {
    border-radius: ${radii['corner-radius-pill']};
    padding: 0 ${space['spacing-giga']};
    display: block;
    width: 100%;
  }

  @media (${media.tablet}) {
    .polygon-pink {
      top: 20%;
      right: 50vw;
      transform: translateX(50%);
    }

    &::after {
      content: '';
      background: ${colors['neutral-background-contrast']};
      position: absolute;
      width: 50vw;
      height: 90%;
      bottom: 0;
      right: 0;
      border-top-left-radius: 100px;
      z-index: 1;
    }

    & > div {
      padding: ${space['spacing-mega']} 0 0;
    }

    .ds-button {
      width: unset;
      background: unset;
      color: ${colors['neutral-text-default']};
      justify-content: center;
      margin-top: ${space['spacing-md']};
      position: relative;
      overflow: hidden;
      z-index: 2;
      
      span {
        position: relative;
        z-index: 2;
      }
    }

    .ds-button::before, .ds-button::after {
      display: block;
      content: ' ';
      background: #01E6FF;
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
      border-radius: ${radii['corner-radius-pill']};
    }

    .ds-button::after {
      background: #35ebff;
      right: 100%;
      z-index: 1;
      transition: .5s;
    }

    .ds-button:hover {
      background: unset;
    }

    .ds-button:hover::after {
      right: 0;
    }
  }

  @media (${media.tablet}) and (max-width: 1239px) {
    & > div > div:last-child {
      padding: 0 ${space['spacing-xl']};
    }

    &::after {
      top: ${space['spacing-xxxl']};
      height: auto;
    }
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;

  img {
    position: relative;
    transition: 2s;
    width: 120%!important;
    height: 100%!important;
    object-fit: cover;
    object-position: left;
    z-index: 0;
  }

  &.animate img {
    width: 100%!important;
  }

  @media (${media.tablet}) {
    height: 100%;

    img {
      width: 100%;
    }
  }
`


export const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-lg']};
  margin: ${space['spacing-xl']} 0;
  position: relative;
  z-index: 2;

  /* Sem caixa: o ícone acima do título é o que separa um item do outro. */
  svg {
    width: 40px;
    height: 40px;
  }

  h3 {
    margin-top: ${space['spacing-xxs']};
  }

  p {
    margin-top: ${space['spacing-xxs']};
  }

  > div {
    opacity: 0;
    transition: opacity 600ms ease;
  }

  /* Escada curta de propósito: com 5 itens, o 7s do layout antigo deixava o
     último visível só muito depois de a seção já estar na tela. */
  > div:nth-child(2) {
    transition-delay: 120ms;
  }

  > div:nth-child(3) {
    transition-delay: 240ms;
  }

  > div:nth-child(4) {
    transition-delay: 360ms;
  }

  > div:nth-child(5) {
    transition-delay: 480ms;
  }

  &.animate > div {
    opacity: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    > div {
      transition: none;
      transition-delay: 0ms;
    }
  }
`

export const BenefitItem = styled.div`
  display: flex;
  flex-direction: column;
`
